export interface Pose {
  x: number;
  y: number;
}

/**
 * Where to draw a body between two simulation ticks.
 * A jump larger than `snapDistance` is a teleport (respawn, safety fix) and is not smeared.
 */
export function blendPose(from: Pose, to: Pose, t: number, snapDistance = 1.25): Pose {
  const dx = to.x - from.x;
  const dy = to.y - from.y;
  if (dx * dx + dy * dy > snapDistance * snapDistance) return { x: to.x, y: to.y };
  const u = Math.min(1, Math.max(0, t));
  return { x: from.x + dx * u, y: from.y + dy * u };
}
